import { Box, Divider, Typography } from '@mui/material';
import { eliminateOjectNotTruthyValues } from '../../lib/helperFuncs';
import { useNavigate } from 'react-router-dom';
import { FO_Status } from '../../lib/static/offices/selectOptions';
import Theme from '../../Themes/main.theme';
import BackButton from '../../components/Buttons/BackButton';
import { useSnackbar } from 'notistack';
import FilmOfficeStepsComp from '../../components/FormContainers/FilmOffice/FilmOfficeStepsComp';
import HttpService from '../../services/HttpService';
import { useTranslation } from 'react-i18next';

export interface ICreateFO{
  title: string;
  address: string;
  address_number: string;
  tk: number | null;
  email: string;
  phone_number: string;
  timeFrom: string;
  timeTo: string;
  regions: string;
  region: { key: string, value: number | null };
  is_enabled: boolean;
}

const AddFilmOffice = () => {

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const {t} = useTranslation();
  const initialValues: ICreateFO = {
    title: '',
    address: '',
    address_number: '',
    tk: null,
    email: '',
    phone_number: '',
    timeFrom: '',
    timeTo: '',    
    regions: '',
    is_enabled: FO_Status[1].value,
    region: { key: '', value: null }
  };

  const onSubmit = async (values: ICreateFO) => {
    const response = await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/registrations/film_office`, 
      eliminateOjectNotTruthyValues({...values, is_enabled: false})
    );
    if (response.status === 201){
      navigate('/admin/units/dashboard');
      enqueueSnackbar(`Επιτυχής Δημιουργία του Film Office: ${response.data.title}`, { variant: 'success' });
    } 
  };

  return (
    <>
      <Box mt={2} mb={2}>
        <BackButton onClick={() => navigate('/admin/units/dashboard')}/>
      </Box>
      <Typography sx={{my: 2}} variant='h2'
        color={Theme?.labelColor?.main}>{t('Δημιουργία Film Office')}</Typography>
      <Divider sx={{mb: 5, border: 1, color: Theme?.dividerColor?.main}}/>
      <FilmOfficeStepsComp initialValues={initialValues} onSubmit={onSubmit}/>
    </>
  );
};

export default AddFilmOffice;